import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import {
  Container,
  Tooltip,
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LinkIcon from "@mui/icons-material/Link";
import LaunchIcon from "@mui/icons-material/Launch";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CategoryIcon from "@mui/icons-material/Category";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ExploreIcon from "@mui/icons-material/Explore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Loader from "../CommonLoader";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Commonfun, timezonechange, timezoneval } from "../Commonfun";
import { AppContext } from "../../../Context/Context";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import "./../style.css";
import "./searchkeyvolumestyle.css";

export default function Topicresearchdetail() {
  const { isMenuExpanded } = useContext(AppContext);
  const navigate = useNavigate();
  const { id, campaign_id } = useParams();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;

  const [loading, setLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [activeTab, setActiveTab] = useState("competitor"); // "competitor" or "ai"
  const [apiopen, setapiOpen] = useState(false);
  const [apierrorMsg, setapierrorMsg] = useState("");

  const apihandleClose = () => {
    setapiOpen(false);
  };

  useEffect(() => {
    if (id && campaign_id) {
      fetchDetailData();
    }
  }, [id, campaign_id]);

  const fetchDetailData = async () => {
    setLoading(true);
    try {
      const userDomainId = esodata.domaindata.value.header_selected;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/content_detail/?user_domain_id=${userDomainId}&campaign_id=${campaign_id}&id=${id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      if (response?.data) {
        setDetailData(response.data);
      } else {
        toast.error("No data returned from the server.");
      }
    } catch (error) {
      console.error("Error fetching topic research details:", error);
      if (
        error?.response?.status === 599 ||
        error?.response?.status === 400 ||
        error?.response?.status === 500
      ) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error || "An API error occurred");
      } else if (error?.code === "ERR_NETWORK" || error?.response?.status === 404) {
        navigate("/errorpages");
      } else {
        toast.error("Failed to fetch detail data.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Helper to safely render intent color
  const getIntentColor = (intent) => {
    if (!intent) return "default";
    const lower = intent.toLowerCase();
    if (lower.includes("informational")) return "info";
    if (lower.includes("transactional")) return "success";
    if (lower.includes("commercial")) return "warning";
    if (lower.includes("navigational")) return "primary";
    return "secondary";
  };

  const pdfdown = async () => {
    setIsDownloading(true);
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}keywords/content_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign_id}&id=${id}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("ContentResearchDetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setIsDownloading(false);
    setLoading(false);

  }

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Content Research Detail Report</title>
      </Helmet>

      {loading && <Loader />}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid" alignItems="center">
            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <button
                  onClick={() => navigate("/content-research")}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "none",
                    border: "1px solid #ff601f",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    color: "#ff601f",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  title="Back to Content Research"
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#ff601f";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#ff601f";
                  }}
                >
                  <ArrowBackIcon />
                </button>
                <h1 className="dashboard_header" style={{ margin: 0 }}>
                  Content Research Detail
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb
                      breadcrumbValue={[
                        { title: "Content" },
                        { title: "Content Research", activeColor: true, link: "/content-research" },
                        { title: "Detail Report", activeColor: true },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container" style={{ marginTop: "20px" }}>
        <Grid item xs={12} md={6}>
          {/* <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button> */}

          <div className="download-pdf-ceneter" style={{ display: "block", textAlign: "end" }}>
            <div className="dashboard_download" style={{ justifyContent: "end", display: "inline-flex", cursor: "pointer" }} onClick={isDownloading ? null : pdfdown}>
              Download PDF
              <svg
                className="filter"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </div>
          </div>
        </Grid>
      </Container>

      {detailData && (
        <>
          {/* Metadata Card */}
          <Container maxWidth={false} className="dashboard-container" style={{ marginTop: "20px" }}>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                background: "linear-gradient(135deg, #ffffff 0%, #f9fbfd 100%)",
                border: "1px solid #eef2f6",
              }}
            >
              <CardContent style={{ padding: "24px" }}>
                <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                  Report Information
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <Typography variant="caption" style={{ color: "#7a8b9e", display: "block" }}>
                      Root Keyword
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600, color: "#0b2033" }}>
                      {detailData.report_info?.root_keyword || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <Typography variant="caption" style={{ color: "#7a8b9e", display: "block" }}>
                      Location
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600, color: "#0b2033", textTransform: "capitalize" }}>
                      {detailData.report_info?.location || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <Typography variant="caption" style={{ color: "#7a8b9e", display: "block" }}>
                      Domain
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600, color: "#0b2033" }}>
                      {detailData.report_info?.domain || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <Typography variant="caption" style={{ color: "#7a8b9e", display: "block" }}>
                      Campaign
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600, color: "#0b2033" }}>
                      {detailData.report_info?.campaign || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <Typography variant="caption" style={{ color: "#7a8b9e", display: "block" }}>
                      Date of request
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 600, color: "#0b2033" }}>
                      {detailData.report_info?.date || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Container>

          {/* Premium Tab Selectors */}
          <Container maxWidth={false} className="dashboard-container" style={{ marginTop: "24px" }}>
            <Box
              style={{
                display: "flex",
                gap: "12px",
                borderBottom: "2px solid #eef2f6",
                paddingBottom: "8px",
              }}
            >
              <button
                onClick={() => setActiveTab("competitor")}
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: activeTab === "competitor" ? "#ff601f" : "#7a8b9e",
                  background: "none",
                  border: "none",
                  borderBottom: activeTab === "competitor" ? "3px solid #ff601f" : "3px solid transparent",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  marginBottom: "-11px",
                }}
              >
                Competitor Insights
              </button>
              <button
                onClick={() => setActiveTab("ai")}
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: activeTab === "ai" ? "#ff601f" : "#7a8b9e",
                  background: "none",
                  border: "none",
                  borderBottom: activeTab === "ai" ? "3px solid #ff601f" : "3px solid transparent",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  marginBottom: "-11px",
                }}
              >
                AI Powered Suggestions
              </button>
            </Box>
          </Container>

          {/* Tab Content: Competitor */}
          {activeTab === "competitor" && (
            <Container maxWidth={false} className="dashboard-container" style={{ marginTop: "24px" }}>
              <Grid container spacing={3}>
                {/* Left Column: Keywords */}
                <Grid item xs={12} lg={8}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Competitor Ranking Keywords
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
                              <TableRow>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="Specific search terms currently driving traffic to competitor sites." arrow>
                                    <Box component="span">Keyword</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="The average number of searches for this term." arrow>
                                    <Box component="span">Search Volume (SV)</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="An estimate of how hard it is to rank for this keyword " arrow>
                                    <Box component="span">Difficulty (Diff)</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="The goal of the searcher (e.g., to learn, to buy, or to find a site)." arrow>
                                    <Box component="span">Intent</Box>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {detailData.extracted_from_competitors?.keywords &&
                                detailData.extracted_from_competitors.keywords.length > 0 ? (
                                detailData.extracted_from_competitors.keywords.map((kw, i) => (
                                  <TableRow key={i} hover>
                                    <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{kw.keyword}</TableCell>
                                    <TableCell align="center">{kw.sv ?? 0}</TableCell>
                                    <TableCell align="center">{kw.diff ?? 0}</TableCell>
                                    <TableCell align="center">
                                      <Chip
                                        label={kw.intent || "Informational"}
                                        size="small"
                                        color={getIntentColor(kw.intent)}
                                        variant="outlined"
                                        style={{ fontWeight: 500 }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={4} align="center" style={{ color: "#7a8b9e" }}>
                                    No keywords found.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Right Column: Scraped URLs */}
                <Grid item xs={12} lg={4}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Reference Source & Competitors
                      </Typography>
                      <Box
                        style={{
                          height: "300px",
                          overflowY: "auto",
                          paddingRight: "8px",
                        }}
                      >
                        {detailData.extracted_from_competitors?.urls_scraped &&
                          detailData.extracted_from_competitors.urls_scraped.length > 0 ? (
                          <List dense>
                            {detailData.extracted_from_competitors.urls_scraped.map((url, i) => (
                              <React.Fragment key={i}>
                                <ListItem
                                  alignItems="flex-start"
                                  style={{ padding: "10px 0" }}
                                >
                                  <Box style={{ marginRight: "8px", color: "#ff601f", display: "inline-flex", pt: "2px" }}>
                                    <LinkIcon fontSize="small" />
                                  </Box>
                                  <ListItemText
                                    primary={
                                      <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "#044792",
                                          textDecoration: "none",
                                          fontSize: "13.5px",
                                          fontWeight: 500,
                                          wordBreak: "break-all",
                                          lineHeight: 1.4,
                                        }}
                                        onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
                                        onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
                                      >
                                        {url}
                                        <LaunchIcon fontSize="inherit" style={{ marginLeft: "4px", fontSize: "10px", verticalAlign: "middle" }} />
                                      </a>
                                    }
                                  />
                                </ListItem>
                                {i < detailData.extracted_from_competitors.urls_scraped.length - 1 && <Divider component="li" />}
                              </React.Fragment>
                            ))}
                          </List>
                        ) : (
                          <Typography variant="body2" style={{ color: "#7a8b9e", textAlign: "center", marginTop: "20px" }}>
                            No scraped URLs available.
                          </Typography>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Topics and Questions */}
                <Grid item xs={12} md={6}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Trending Content Topics
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table size="small" stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
                              <TableRow>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="Popular themes and subjects appearing frequently in competitor content." arrow>
                                    <Box component="span">Topic</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="count of top competitors covering this specific topic." arrow>
                                    <Box component="span">Competitor Prevalance</Box>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {detailData.extracted_from_competitors?.topics &&
                                detailData.extracted_from_competitors.topics.length > 0 ? (
                                detailData.extracted_from_competitors.topics.map((t, i) => (
                                  <TableRow key={i} hover>
                                    <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{t.topic}</TableCell>
                                    <TableCell align="center">
                                      <Chip label={`${t.pages} pages`} size="small" style={{ backgroundColor: "#eef2f6", color: "#103658", fontWeight: 500 }} />
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={2} align="center" style={{ color: "#7a8b9e" }}>
                                    No topics identified.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Intent-Driven FAQs
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table size="small" stickyHeader>
                           <TableHead style={{ backgroundColor: "#f9fbfd" }}>
  <TableRow>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
      <Tooltip title="Real user queries that competitors are answering on their pages." arrow>
        <Box component="span">Question</Box>
      </Tooltip>
    </TableCell>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="The number of unique source URLs where this question was found." arrow>
        <Box component="span">Pages Scraped</Box>
      </Tooltip>
    </TableCell>
    {/* Added SV with Tooltip */}
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="Average monthly search volume for this question." arrow>
        <Box component="span">SV</Box>
      </Tooltip>
    </TableCell>
    {/* Added Diff with Tooltip */}
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="Estimated difficulty to rank for this question." arrow>
        <Box component="span">Diff</Box>
      </Tooltip>
    </TableCell>
  </TableRow>
</TableHead>
<TableBody>
  {detailData.extracted_from_competitors?.questions &&
    detailData.extracted_from_competitors.questions.length > 0 ? (
    detailData.extracted_from_competitors.questions.map((q, i) => (
      <TableRow key={i} hover>
        <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{q.question}</TableCell>
        <TableCell align="center">
          <Chip label={`${q.pages} pages`} size="small" style={{ backgroundColor: "#eef2f6", color: "#103658", fontWeight: 500 }} />
        </TableCell>
        {/* ADD THESE TWO LINES HERE */}
        <TableCell align="center">{q.sv ?? 0}</TableCell>
        <TableCell align="center">{q.diff ?? 0}</TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={4} align="center" style={{ color: "#7a8b9e" }}>
        No questions found.
      </TableCell>
    </TableRow>
  )}
</TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Container>
          )}

          {/* Tab Content: AI suggestions */}
          {activeTab === "ai" && (
            <Container maxWidth={false} className="dashboard-container" style={{ marginTop: "24px" }}>
              <Grid container spacing={3}>
                {/* Row 1: Opportunity Keywords & SEO Strategy View */}
                <Grid item xs={12} md={6}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Recommended Keywords
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
                              <TableRow>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="Specific search terms currently driving traffic to competitor sites." arrow>
                                    <Box component="span">Keyword</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="The average number of searches for this term." arrow>
                                    <Box component="span">Search Volume (SV)</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="An estimate of how hard it is to rank for this keyword" arrow>
                                    <Box component="span">Difficulty (Diff)</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="The goal of the searcher (e.g., to learn, to buy, or to find a site)." arrow>
                                    <Box component="span">Intent</Box>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {detailData.generated_by_ai?.opportunity_keywords &&
                                detailData.generated_by_ai.opportunity_keywords.length > 0 ? (
                                detailData.generated_by_ai.opportunity_keywords.map((kw, i) => (
                                  <TableRow key={i} hover>
                                    <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{kw.keyword}</TableCell>
                                    <TableCell align="center">{kw.sv ?? 0}</TableCell>
                                    <TableCell align="center">{kw.diff ?? 0}</TableCell>
                                    <TableCell align="center">
                                      <Chip
                                        label={kw.intent || "Informational"}
                                        size="small"
                                        color={getIntentColor(kw.intent)}
                                        variant="outlined"
                                        style={{ fontWeight: 500 }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={4} align="center" style={{ color: "#7a8b9e" }}>
                                    No opportunity keywords found.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Row 2: SEO Strategy View */}
                <Grid item xs={12} md={6}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Strategy Content Roadmap
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
                              <TableRow>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="" arrow>
                                    <Box component="span">Topic Area</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="" arrow>
                                    <Box component="span">Content Opportunity</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="" arrow>
                                    <Box component="span">Opportunity Insights</Box>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {detailData.generated_by_ai?.strategy_view &&
                                detailData.generated_by_ai.strategy_view.length > 0 ? (
                                detailData.generated_by_ai.strategy_view.map((strategy, i) => (
                                  <TableRow key={i} hover>
                                    <TableCell style={{ color: "#ff601f", fontWeight: 600 }}>{strategy.cluster}</TableCell>
                                    <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{strategy.opportunity}</TableCell>
                                    <TableCell style={{ color: "#7a8b9e" }}>{strategy.reason}</TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={3} align="center" style={{ color: "#7a8b9e" }}>
                                    No strategy recommendations found.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>



                {/* Row 3: Competitor Insights */}
                <Grid item xs={12}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "20px" }}>
                        Performance & Gap Analysis
                      </Typography>
                      <Grid container spacing={3}>
                        {/* Gaps */}
                        <Grid item xs={12} md={4}>
                          <Box style={{ backgroundColor: "#fff5f5", padding: "16px", borderRadius: "8px", border: "1px solid #ffe3e3" }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#c13535", display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                              <TipsAndUpdatesIcon fontSize="small" /> Content Gaps
                            </Typography>
                            <Box style={{ height: "300px", overflowY: "auto" }}>
                              <List dense>
                                {detailData.generated_by_ai?.competitor_insights?.content_gaps &&
                                  detailData.generated_by_ai.competitor_insights.content_gaps.length > 0 ? (
                                  detailData.generated_by_ai.competitor_insights.content_gaps.map((gap, j) => (
                                    <ListItem key={j}>
                                      <ListItemText primary={<span style={{ fontWeight: 500, color: "#542424" }}>• {gap}</span>} />
                                    </ListItem>
                                  ))
                                ) : (
                                  <Typography variant="body2" style={{ color: "#7a8b9e" }}>No content gaps detected.</Typography>
                                )}
                              </List>
                            </Box>
                          </Box>
                        </Grid>

                        {/* Common Topics */}
                        <Grid item xs={12} md={4}>
                          <Box style={{ backgroundColor: "#f0f7ff", padding: "16px", borderRadius: "8px", border: "1px solid #e1f0ff" }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#0066cc", display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                              <CategoryIcon fontSize="small" /> Common Topics Covered
                            </Typography>
                            <Box style={{ height: "300px", overflowY: "auto" }}>
                              <List dense>
                                {detailData.generated_by_ai?.competitor_insights?.common_topics &&
                                  detailData.generated_by_ai.competitor_insights.common_topics.length > 0 ? (
                                  detailData.generated_by_ai.competitor_insights.common_topics.map((topic, j) => (
                                    <ListItem key={j}>
                                      <ListItemText primary={<span style={{ fontWeight: 500, color: "#1c3c5e" }}>• {topic}</span>} />
                                    </ListItem>
                                  ))
                                ) : (
                                  <Typography variant="body2" style={{ color: "#7a8b9e" }}>No common topics found.</Typography>
                                )}
                              </List>
                            </Box>
                          </Box>
                        </Grid>

                        {/* Missing Topics */}
                        <Grid item xs={12} md={4}>
                          <Box style={{ backgroundColor: "#f9f0ff", padding: "16px", borderRadius: "8px", border: "1px solid #f3e0ff" }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#800080", display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                              <ExploreIcon fontSize="small" /> Missing Topics
                            </Typography>
                            <Box style={{ height: "300px", overflowY: "auto" }}>
                              <List dense>
                                {detailData.generated_by_ai?.competitor_insights?.missing_topics &&
                                  detailData.generated_by_ai.competitor_insights.missing_topics.length > 0 ? (
                                  detailData.generated_by_ai.competitor_insights.missing_topics.map((topic, j) => (
                                    <ListItem key={j}>
                                      <ListItemText primary={<span style={{ fontWeight: 500, color: "#422054" }}>• {topic}</span>} />
                                    </ListItem>
                                  ))
                                ) : (
                                  <Typography variant="body2" style={{ color: "#7a8b9e" }}>No missing topics found.</Typography>
                                )}
                              </List>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Row 4: Content Ideas & AI Questions */}
                <Grid item xs={12} md={6}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        High Impact Content Breif
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
                              <TableRow>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="The proposed title or core subject for a new piece of content based on identified competitor gaps and keyword opportunities." arrow>
                                    <Box component="span">Suggested Content</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">Search Volume (SV)</TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">Difficulty (Diff)</TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="The goal of the searcher (e.g., to learn, to buy, or to find a site)." arrow>
                                    <Box component="span">Intent</Box>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {detailData.generated_by_ai?.content_ideas &&
                                detailData.generated_by_ai.content_ideas.length > 0 ? (
                                detailData.generated_by_ai.content_ideas.map((idea, i) => (
                                  <TableRow key={i} hover>
                                    <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{idea.title}</TableCell>
                                    {/* <TableCell align="center">{idea.sv ?? 0}</TableCell>
                                    <TableCell align="center">{idea.diff ?? 0}</TableCell> */}
                                    <TableCell align="center">
                                      <Chip
                                        label={idea.intent || "Informational"}
                                        size="small"
                                        color={getIntentColor(idea.intent)}
                                        variant="outlined"
                                        style={{ fontWeight: 500 }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={4} align="center" style={{ color: "#7a8b9e" }}>
                                    No content ideas generated.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Row 5: AI Suggested Questions */}
                <Grid item xs={12} md={6}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Suggested FAQ and PAA (People Also Asked)
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
  <TableRow>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
      <Tooltip title="'People Also Ask' queries that appear directly on Google Search results." arrow>
        <Box component="span">Suggested Question</Box>
      </Tooltip>
    </TableCell>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="Average monthly search volume for this suggested question." arrow>
        <Box component="span">SV</Box>
      </Tooltip>
    </TableCell>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="Estimated difficulty to rank for this suggested question." arrow>
        <Box component="span">Diff</Box>
      </Tooltip>
    </TableCell>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="Suggested urgency for implementation (High, Medium, or Low)." arrow>
        <Box component="span">Priority</Box>
      </Tooltip>
    </TableCell>
    <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
      <Tooltip title="The goal of the searcher (e.g., to learn, to buy, or to find a site)." arrow>
        <Box component="span">Intent</Box>
      </Tooltip>
    </TableCell>
  </TableRow>
</TableHead>
<TableBody>
  {detailData.generated_by_ai?.ai_suggested_questions &&
    detailData.generated_by_ai.ai_suggested_questions.length > 0 ? (
    detailData.generated_by_ai.ai_suggested_questions.map((q, i) => (
      <TableRow key={i} hover>
        <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{q.question}</TableCell>
        {/* ADD SV and DIFF DATA HERE */}
        <TableCell align="center">{q.sv ?? 0}</TableCell>
        <TableCell align="center">{q.diff ?? 0}</TableCell>
        <TableCell align="center">
          <Chip
            label={q.priority || "Medium"}
            size="small"
            color={q.priority?.toLowerCase() === "high" ? "error" : "default"}
            style={{ fontWeight: 600, fontSize: "11px" }}
          />
        </TableCell>
        <TableCell align="center">
          <Chip
            label={q.intent || "Informational"}
            size="small"
            color={getIntentColor(q.intent)}
            variant="outlined"
            style={{ fontWeight: 500 }}
          />
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={5} align="center" style={{ color: "#7a8b9e" }}>
        No questions suggested.
      </TableCell>
    </TableRow>
  )}
</TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>



                {/* Row 6: Topic Clusters Map */}
                <Grid item xs={12}>
                  <Card style={{ borderRadius: "10px", border: "1px solid #eef2f6", boxShadow: "0 4px 12px rgba(0,0,0,0.03)" }}>
                    <CardContent>
                      <Typography variant="h6" style={{ fontWeight: 600, color: "#103658", marginBottom: "16px" }}>
                        Topic Clusters Map
                      </Typography>
                      <Box style={{ height: "300px", overflowY: "auto" }}>
                        <TableContainer component={Paper} elevation={0} style={{ border: "1px solid #eef2f6", borderRadius: "8px" }}>
                          <Table stickyHeader>
                            <TableHead style={{ backgroundColor: "#f9fbfd" }}>
                              <TableRow>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="The primary 'Pillar' topic that groups multiple sub-keywords." arrow>
                                    <Box component="span">Cluster Name</Box>
                                  </Tooltip>
                                </TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }}>
                                  <Tooltip title="Support keywords to be used within this content cluster." arrow>
                                    <Box component="span">Keyword</Box>
                                  </Tooltip>
                                </TableCell>
                                {/* <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">Search Volume (SV)</TableCell>
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">Difficulty (Diff)</TableCell> */}
                                <TableCell style={{ fontWeight: 600, color: "#103658", backgroundColor: "#f9fbfd" }} align="center">
                                  <Tooltip title="The goal of the searcher (e.g., to learn, to buy, or to find a site)." arrow>
                                    <Box component="span">Intent</Box>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {detailData.generated_by_ai?.topic_clusters &&
                                detailData.generated_by_ai.topic_clusters.length > 0 ? (
                                detailData.generated_by_ai.topic_clusters.flatMap((cluster, i) =>
                                  cluster.keywords && cluster.keywords.length > 0 ? (
                                    cluster.keywords.map((kw, j) => (
                                      <TableRow key={`${i}-${j}`} hover>
                                        <TableCell style={{ color: "#103658", fontWeight: 600 }}>{j === 0 ? cluster.cluster_name : ""}</TableCell>
                                        <TableCell style={{ color: "#0b2033", fontWeight: 500 }}>{kw.keyword}</TableCell>
                                        {/* <TableCell align="center">{kw.sv ?? 0}</TableCell>
                                        <TableCell align="center">{kw.diff ?? 0}</TableCell> */}
                                        <TableCell align="center">
                                          <Chip
                                            label={cluster.intent || "Informational"}
                                            size="small"
                                            color={getIntentColor(cluster.intent)}
                                            variant="outlined"
                                            style={{ fontWeight: 500 }}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (
                                    <TableRow key={`${i}-empty`} hover>
                                      <TableCell style={{ color: "#103658", fontWeight: 600 }}>{cluster.cluster_name}</TableCell>
                                      <TableCell colSpan={4} align="center" style={{ color: "#7a8b9e" }}>
                                        No keywords in this cluster.
                                      </TableCell>
                                    </TableRow>
                                  )
                                )
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={5} align="center" style={{ color: "#7a8b9e" }}>
                                    No topic clusters generated.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Container>
          )}

          {/* Footer Panel */}
          <Container maxWidth={false} className="footer-container" style={{ marginTop: "40px" }}>
            <Box className="footer-box">
              <Grid container className="footer-grid">
                <Grid item xs={12} md={6}>
                  <div className="footer-left">
                    <p className="footer-text">
                      All Rights Reserved Copyright © 2026 |{" "}
                      <a href="https://www.egrovesys.com/" target="blank">
                        <span className="footer-brand">Elite site Optimizer</span>
                      </a>
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </>
      )}

      {/* Common Alert Dialogs for Errors */}
      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: true,
        }}
        closeAlert={apihandleClose}
      />
    </div>
  );
}
